import { render, staticRenderFns } from "./DefaultCreatorSelect.vue?vue&type=template&id=50ff8e83"
import script from "./DefaultCreatorSelect.vue?vue&type=script&lang=ts"
export * from "./DefaultCreatorSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ff8e83')) {
      api.createRecord('50ff8e83', component.options)
    } else {
      api.reload('50ff8e83', component.options)
    }
    module.hot.accept("./DefaultCreatorSelect.vue?vue&type=template&id=50ff8e83", function () {
      api.rerender('50ff8e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/DefaultCreatorSelect.vue"
export default component.exports